import React from 'react';
import { Link } from 'react-router-dom';
import { LayoutContext } from '../components/LayoutProvider';

const NotFound = () => {
	console.log("Rendering NotFound...");
	const { setIsHeaderVisible, setIsFooterVisible } = React.useContext(LayoutContext);

	React.useEffect(() => {
		setIsHeaderVisible(false);
		setIsFooterVisible(false);
		
		return () => {
			setIsHeaderVisible(true);
			setIsFooterVisible(true);
		};
	}, [setIsHeaderVisible, setIsFooterVisible]);

	return (
		<>
			<div className="bg-pattern-gear flex min-h-screen w-full">
				<div className="flex flex-col w-full items-center justify-center">
					<div className="text-center">
						<h1 className="text-9xl font-extrabold">404</h1>
						<p className="text-2xl font-medium py-6">Oops.. Something went wrong.</p>
						<Link to="/"
							className="btn-main w-full text-white uppercase font-bold text-base px-4 py-1 rounded-md text-center transition ease-in-out hover:-translate-y-0.5 hover:scale-105 hover:text-white"
						>
							Back to start
						</Link>
					</div>
				</div>
			</div>
		</>
	);
};

export default NotFound;
